import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';

import Amplify, { Storage } from 'aws-amplify';
import awsconfig from './aws-exports';
import { FocusStyleManager } from '@blueprintjs/core';
Amplify.configure(awsconfig);
Storage.configure({ track: true });
FocusStyleManager.onlyShowFocusOnTabs();
ReactDOM.render(<App />, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
